
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/landing/search",
      function () {
        return require("private-next-pages/landing/search.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/landing/search"])
      });
    }
  